<template>
    <div class="column-layout">
        <div v-if="multiSelect" class="table-layout">
            <el-table :data="devcMaintProofList" border ref="multipleTable" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column v-if="multiSelect" type="selection" align="center" width="55"></el-table-column>
                <el-table-column prop="title" label="标题" align="left" width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="period" label="周期" align="center" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="standard" label="参考标准" align="left" width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="appliedCatNames" label="适用分类" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="table-layout" v-else>
            <el-table :data="devcMaintProofList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : hashCheckedRow(rows.row)}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="标题" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="period" label="周期" align="center" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="standard" label="参考标准" align="left" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="appliedCatNames" label="适用分类" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import {Utils, EventBus} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    //
    import devcMaintApi from '../../api/devcMaint'
    //
    export default {
        name: 'swb-devc-maint-proof-for-select',
        desc: '凭单-选择',
        props: {
            multiSelect: {  // 是否多选
                type: Boolean,
                default: true
            },
            initCheckedItem: {
                type: Object,
                default: null
            },
            checkedIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            isOperator: {
                type: Boolean,
                default: true
            },
            appliedWorkType: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                //分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //复选信息
                checkedIdsX: [],
                checkedIdMap: {},
                checkedDelay: 100,
                checkedIniting: false,
                checkedTblRefId: 'multipleTable',
                checkedList: [],
                checkInfo: {},
                //
                devcMaintProofList: [],
            }
        },
        created: function () {
            let self = this;
            this.pageSize = this.pageSizes.first();
            //
            if (this.multiSelect) {
                self.checkedIds.forEach(function (id) {
                    self.checkedIdsX.add(id);
                    //
                    let item = {};
                    item.id = id;
                    self.checkedIdMap[id + ''] = merge({}, item);
                });
            } else {
                if (self.initCheckedItem != null) {
                    let item = self.initCheckedItem;
                    //
                    self.checkedIdsX.add(item.id);
                    //
                    self.checkedIdMap[item.id + ''] = merge({}, item);
                }
            }
            //
            this.getDevcMaintProofList();
        },
        methods: {
            // ===================== 分页多选开始 ==============================
            addCheckId: function (item, val) {
                let id = item.id;
                if (!this.multiSelect) {
                    this.checkedIdsX = [];
                    this.checkedIdMap = {};
                }
                if (!this.checkedIdsX.contains(id)) {
                    this.checkedIdsX.add(id);
                    this.checkedIdMap[id + ''] = item;
                    return item;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                if (self.checkedIdsX.contains(id)) {
                    self.checkedIdsX.remove(id);
                    //
                    delete this.checkedIdMap[id + ''];
                    //
                    return id;
                }
                return null;
            },
            handleCurrentChange: function (val) {
                this.handleSelectionChange([val]);
            },
            handleSelectionChange: function (selRows) {
                let self = this;
                if (self.checkedIniting) {
                    return;
                }
                let allIds = self.devcMaintProofList.pluck("id");
                let selIds = selRows.pluck("id");
                selRows.forEach(function (item, index) {
                    selIds.add(item.id);
                    //
                    self.addCheckId(item, selRows[index]);
                });

                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id);
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "id";
                let allIds = dataRows.pluck(idProp);
                let selIds = Utils.compareArrays(allIds, this.checkedIdsX)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                setTimeout(function () {
                    self.checkedIniting = false;
                }, 100);
            },
            hashCheckedId(id){
                return this.checkedIdsX.contains(id);
            },
            hashCheckedRow(row){
                let checkId = row["id"];
                return this.checkedIdsX.contains(checkId);
            },
            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                //
                idProp = idProp || "id";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if (theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },
            // ===================== 分页多选结束 ==============================
            selectable: function (row, index) {     // 回显禁用
                let self = this;
                let checkedIds = self.checkedIds;
                if (checkedIds.indexOf(row.id) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            //
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                //
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if (this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                //
                this.pageNumber = val;
                //
                this.getDevcMaintProofList();
            },
            getDevcMaintProofList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.disabled = false;
                if (self.isOperator) {
                    filterItems.merchantId = -1;    // 运营商
                    filterItems.merchantType = 1;
                }
                filterItems.includeItems = true;
                //
                if (!Utils.isNoB(this.appliedWorkType)) {
                    filterItems.appliedWorkType = this.appliedWorkType;
                }
                postData.filterItems = filterItems;
                //
                let theLoad = MsgBox.loading();
                devcMaintApi.getDevcMaintProofList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        let resultData = result.data;
                        //
                        self.devcMaintProofList = resultData.rows;
                        //
                        let pagination = resultData.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        setTimeout(function () {
                            self.restoreSelRows(self.devcMaintProofList, self.checkedTblRefId, 'id');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = 'info';
                //
                let checkedIdsX = self.checkedIdsX;
                if (!Utils.isNoB(checkedIdsX) && checkedIdsX.length > 0) {
                    if (this.multiSelect) {   // 多选
                        result.data = checkedIdsX.map(function (id) {
                            return self.checkedIdMap[id + ''];
                        });
                    } else {
                        // 单选
                        let checkedId = self.checkedIdsX.first();
                        if (checkedId != null) {
                            result.data = this.checkedIdMap[checkedId + ''];
                        }
                    }
                } else {
                    result.type = 'warn';
                    result.message = "请选择保养凭单";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcMaint/DevcMaintProofSelect.vue